import { makeStyles } from '@material-ui/core/styles';
import { variables } from '../../styles';

export const useStyles = makeStyles((theme) => ({
  selectIcon: {
    marginInlineEnd: theme.spacing(2),
    color: variables.cadetBlue,
  },
  selectControl: {
    color: variables.richBlack,
    borderRadius: 3,
    '&::before': {
      display: 'none',
    },
  },
  selectContainer: {
    width: '100%',
    height: 48,
    borderRadius: 8,
    backgroundColor: variables.greyLight,
    border: 0,
    textAlign: 'start',
    color: variables.richBlack,
    boxSizing: 'border-box',

    '&::before': {
      display: 'none',
    },

    '&::after': {
      border: 'none',
    },

    '&:hover': {
      border: 0,
    },

    '& fieldset': {
      border: 'none',
    },
    '& .MuiSelect-root': {
      paddingTop: 8,
      paddingBottom: 8,
    },
    '& .MuiSelect-root:focus': {
      border: '1px solid black',
      borderRadius: 8,
      alignContent: 'center',
      height: 32,
      paddingTop: 8,
      paddingBottom: 8,
    },
  },
  inputField: {
    width: '100%',
    height: 48,
    borderRadius: 8,
    backgroundColor: variables.greyLight,
    color: variables.richBlack,
    border: 0,
    textAlign: 'start',

    '& fieldset': {
      border: 'none',
    },

    '&.Mui-focused, & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '1px solid black',
      borderRadius: 8,
    },
  },
  errorDescription: {
    display: 'flex',
    color: variables.red,
    margin: theme.spacing(1, 0, 0, 0.5),
  },
  rtlIcon: {
    '& .MuiSvgIcon-root': {
      right: 'unset',
      left: '7px',
    },
  },
  chip: {
    height: '19px !important',
    borderRadius: '4px !important',
    paddingRight: '4px !important',
    paddingLeft: '4px !important',
    backgroundColor: `${variables.black5} !important`,
    color: `${variables.richBlack} !important`,
    marginRight: '4px !important',
  },
}));
